module.exports = __webpack_public_path__ + "static/media/61611-Immediate Suspension Order and Notice of Proposal to Suspend.23cb7901.pdf";